import React, { Component } from "react";
import { Redirect, Link } from 'react-router-dom';
import ReactFullpage from '@fullpage/react-fullpage';
import styles from '../assets/scss/modules/program.module.scss';
import twitter from "../assets/media/images/Twitter.png";
import tiktok from "../assets/media/images/Tiktok.png";
import instagram from "../assets/media/images/Instagram.png";
import facebook from "../assets/media/images/Facebook.png";
import jogasz from "../assets/media/images/jogasz.png";
import kepviselo from "../assets/media/images/kepviselo.png";
import csalad from "../assets/media/images/csalad.png";
import asset1 from "../assets/media/images/asset1.png";
import asset2 from "../assets/media/images/asset2.png";
import asset3 from "../assets/media/images/asset3.png";
import asset4 from "../assets/media/images/asset4.png";
import asset5 from "../assets/media/images/Titles/talalkozzunk.png";
import asset6 from "../assets/media/images/asset6.png";
import gradiensProgram from "../assets/media/images/gradiensProgram.png";
import back_btn from "../assets/media/newicons/back.png";
import forward_btn from "../assets/media/newicons/forward.png";
import back_btn_black from "../assets/media/newicons/back-black.png";
import forward_btn_black from "../assets/media/newicons/nextBlue.png";
import erikfoto from "../assets/media/images/Erik-foto.png";
import bild from "../assets/media/images/ProgramImages/Tata.png";
import konczer_facebook from "../assets/media/images/konczer-facebook.png";
import Footer from "../components/Footer/Footer";
import FooterResponziv from "../components/Footer/FooterResponziv";
import NavbarComponent from "../NavbarComponent";
import { Scrollbar } from "react-scrollbars-custom";

import{
	MDBContainer,
  MDBScrollbar,
	MDBSmoothScroll,
	MDBRow,
	MDBCol,
	MDBCard,
	MDBCardHeader,
	MDBCardBody,
  MDBBtn,
} from 'mdbreact';

class ProgramokTata extends Component {

	constructor(props) {
    super(props);
    this.state = {navbarPaddingTop: true,
									};
  };

	componentDidMount() {
		document.addEventListener("scroll", this.scrollEventListener);
	}

	componentWillUnmount() {
	}

	scrollEventListener = (event) => {
		const navPadding = window.scrollY < 100 ? true : false;
		this.setState({ navbarPaddingTop: navPadding});
	}


  render() {
		const anchors = ["program1", "program2", "program3"];
    return (
        <MDBContainer fluid className="fluid-container">
					<div className="d-none d-lg-block">
	          <div className={styles.bodywrapper}>
						<NavbarComponent/>
							<img className="bild3" src={bild}></img>
							<MDBContainer fluid className="program-container-programok">
							<img className="gradiensProgram" src={gradiensProgram}></img>
							<Scrollbar
										id="scrollbar"
										style={{ width: "100%", height: "70vh", marginTop: "-145px"}}
										maximalThumbYSize = {150}
										noScrollX = {true}
										>


								<MDBRow className="program-row">
									<MDBCol>
									<span className="program-title">Mit kíván Tatabánya, Tata, Baj, Szárliget, Vértesszőlős?</span><br/>
									<span className="program-text">Legyen társadalmi béke, szabadság és kormányváltás. Követeljük:</span><br/><br/>
									<ul className="program-text">1.	A sajtó szabadságát, a fideszes cenzúra megszüntetését Tatabányán és az egész országban!</ul><br/>
									<ul className="program-text">2.	Tatabánya elvont forrásainak visszatérítését!</ul><br/>
									<ul className="program-text">3.	Helyi népszavazást Tatán az Avalon beruházásról! Ne valósulhasson meg olyan beruházás,
									ami veszélyezteti az Öreg-tó körbejárhatóságát!</ul><br/>
									<ul className="program-text">4.	Mindenki számára elérhető, közfinanszírozott egészségügyet! Megbecsülést a
									Szent Borbála Kórház dolgozóinak, korszerű ellátást Tatán és Tatabányán!</ul><br/>
									<ul className="program-text">5.	A tatabányai vasútállomás akadálymentesítését és felújítását!</ul><br/>
									<ul className="program-text">6.	Kevesebb forgalmat a településeken, ingyenes Tatabánya-Tata közti autópályaszakaszt!</ul><br/>
									<ul className="program-text">7.	Karsztvizünk megóvását! Ipari célra ivóvizünket nem adjuk!</ul><br/>
									<ul className="program-text">8.	Bérlakás programot, lakhatási támogatást, újraindított panelprogramot!</ul><br/>
									<ul className="program-text">9.	Méltó időskort, modern szociális ellátást!</ul><br/>
									<ul className="program-text">10.	Emberközpontú beruházásokat! Fásítási programot, növekvő zöldfelületeket! </ul><br/>
									<ul className="program-text">11.	A helyi kiváltságosok elszámoltatását, tiszta közéletet!</ul><br/>
									<ul className="program-text">12.	Kevesek urizálása és a sokak elszegényedése helyett általános polgári jólétet!</ul><br/><br/>
									<span className="program-title">Tisztesség, elszántság, együttműködés!</span><br/><br/>
									</MDBCol>
								</MDBRow>
							</Scrollbar>

							</MDBContainer>
							<div className="fixed-bottom d-none d-lg-block">
								<Footer/>
							</div>
						</div>
					</div>
					<div className="d-block d-lg-none">
					<img className="bild4" src={bild}></img>
					<MDBContainer fluid className="fluid-container">
	          <div className={styles.bodywrapper2}>
							<div className={this.state.navbarPaddingTop ? "landing-nav-container" : "landing-nav-container-scroll"}>
								<MDBRow className="m-0" style={{width: "100%", height: "24px"}}>
									<MDBCol middle size="1" className="text-right pl-0 pr-3">
										<MDBRow end className="m-0 p-0">
											<Link flat to="/"><img className="back-btn" src={back_btn_black}></img></Link>
										</MDBRow>
									</MDBCol>
									<MDBCol middle size="5" className="text-left p-0">
										<MDBRow start className="m-0">
											<Link flat to="/"><span className="back-text text-capitalize">Vissza</span></Link>
										</MDBRow>
									</MDBCol>
									{!this.state.navbarPaddingTop ?
									<>
									<MDBCol middle size="5" className="text-right p-0">
										<MDBRow end className="m-0">
											<Link to="/ProgramokTatabanya"><span className="back-text text-capitalize">Tatabánya</span></Link>
										</MDBRow>
									</MDBCol>
									<MDBCol middle size="1" className="text-left pr-0 pl-3">
										<MDBRow start className="m-0">
											<Link to="/ProgramokTatabanya"><img className="forward-btn" src={forward_btn_black}></img></Link>
										</MDBRow>
									</MDBCol>
									</>:false}
								</MDBRow>
							</div>
						</div>
						<div className={styles.bodywrapper3}>
							<MDBRow className="program-row">
								<MDBCol>
								<span className="program-title">Mit kíván Tatabánya, Tata, Baj, Szárliget, Vértesszőlős?</span><br/><br/>
								<span className="program-text">Legyen társadalmi béke, szabadság és kormányváltás. Követeljük:</span><br/><br/>
								<ul className="program-text" style={{paddingLeft: "15px"}}>1.	A sajtó szabadságát, a fideszes cenzúra megszüntetését Tatabányán és az egész országban!</ul><br/>
								<ul className="program-text" style={{paddingLeft: "15px"}}>2.	Tatabánya elvont forrásainak visszatérítését!</ul><br/>
								<ul className="program-text" style={{paddingLeft: "15px"}}>3.	Helyi népszavazást Tatán az Avalon beruházásról! Ne valósulhasson meg olyan beruházás,
								ami veszélyezteti az Öreg-tó körbejárhatóságát!</ul><br/>
								<ul className="program-text" style={{paddingLeft: "15px"}}>4.	Mindenki számára elérhető, közfinanszírozott egészségügyet! Megbecsülést a
								Szent Borbála Kórház dolgozóinak, korszerű ellátást Tatán és Tatabányán!</ul><br/>
								<ul className="program-text" style={{paddingLeft: "15px"}}>5.	A tatabányai vasútállomás akadálymentesítését és felújítását!</ul><br/>
								<ul className="program-text" style={{paddingLeft: "15px"}}>6.	Kevesebb forgalmat a településeken, ingyenes Tatabánya-Tata közti autópályaszakaszt!</ul><br/>
								<ul className="program-text" style={{paddingLeft: "15px"}}>7.	Karsztvizünk megóvását! Ipari célra ivóvizünket nem adjuk!</ul><br/>
								<ul className="program-text" style={{paddingLeft: "15px"}}>8.	Bérlakás programot, lakhatási támogatást, újraindított panelprogramot!</ul><br/>
								<ul className="program-text" style={{paddingLeft: "15px"}}>9.	Méltó időskort, modern szociális ellátást!</ul><br/>
								<ul className="program-text" style={{paddingLeft: "15px"}}>10.	Emberközpontú beruházásokat! Fásítási programot, növekvő zöldfelületeket! </ul><br/>
								<ul className="program-text" style={{paddingLeft: "15px"}}>11.	A helyi kiváltságosok elszámoltatását, tiszta közéletet!</ul><br/>
								<ul className="program-text" style={{paddingLeft: "15px"}}>12.	Kevesek urizálása és a sokak elszegényedése helyett általános polgári jólétet!</ul><br/>
								<span className="program-title" style={{textAlign: "center"}}>Tisztesség, elszántság, együttműködés!</span><br/><br/><br/>
								</MDBCol>
							</MDBRow>
						</div>
					</MDBContainer>
					<MDBContainer fluid className="fluid-container">
	          <div className={styles.bodywrapper4}>
	            <FooterResponziv/>
	          </div>
	        </MDBContainer>
					</div>
	      </MDBContainer>
    );
  }
}
export default  ProgramokTata;
